import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0F172A;
  padding: 2rem;
`;

const NotFoundContent = styled.div`
  text-align: center;
  color: white;
  max-width: 500px;
`;

const NotFoundIcon = styled.div`
  font-size: 6rem;
  margin-bottom: 1rem;
`;

const NotFoundTitle = styled.h1`
  font-size: 3rem;
  margin: 0 0 1rem 0;
  font-weight: bold;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const NotFoundMessage = styled.p`
  font-size: 1.2rem;
  margin: 0 0 2rem 0;
  opacity: 0.9;
  line-height: 1.6;
`;

const NavigationButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const NavButton = styled(Link)`
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  
  &.primary {
    background: white;
    color: ${props => props.theme.colors.primary};
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }
  }
  
  &.secondary {
    background: transparent;
    color: white;
    border: 2px solid white;
    
    &:hover {
      background: white;
      color: ${props => props.theme.colors.primary};
    }
  }
`;

const NotFound = () => {
  return (
    <NotFoundContainer>
      <NotFoundContent>
        <NotFoundIcon>🔍</NotFoundIcon>
        <NotFoundTitle>404</NotFoundTitle>
        <NotFoundMessage>
          Oops! The page you're looking for doesn't exist. 
          It might have been moved, deleted, or you entered the wrong URL.
        </NotFoundMessage>
        <NavigationButtons>
          <NavButton to="/" className="primary">
            Go Home
          </NavButton>
          <NavButton to="/login" className="secondary">
            Sign In
          </NavButton>
        </NavigationButtons>
      </NotFoundContent>
    </NotFoundContainer>
  );
};

export default NotFound; 